// types.ts
import styled from "styled-components";

export const Error = styled.p`
  color: red;
  margin-left: 4px;
  margin-top: 4px;
  font-size: 12px;
`;

export interface ButtonType {
  type: "URL" | "PHONE_NUMBER" | "QUICK_REPLY";  // ← ADD QUICK_REPLY
  text: string;
  url?: string;
  phone_number?: string;
}

// constants.ts
export const MAX_BUTTON_TEXT_LENGTH = 25;
export const MAX_URL_LENGTH = 2000;
// ADD this validation function
export const validateButtonGrouping = (buttons: ButtonType[]): { isValid: boolean; error?: string } => {
  const quickReplyButtons = buttons.filter(btn => btn.type === "QUICK_REPLY");
  const nonQuickReplyButtons = buttons.filter(btn => btn.type !== "QUICK_REPLY");
  
  if (quickReplyButtons.length === 0 || nonQuickReplyButtons.length === 0) {
    return { isValid: true };
  }
  
  const quickReplyPositions: number[] = [];
  buttons.forEach((button, index) => {
    if (button.type === "QUICK_REPLY") {
      quickReplyPositions.push(index);
    }
  });
  
  for (let i = 1; i < quickReplyPositions.length; i++) {
    if (quickReplyPositions[i] !== quickReplyPositions[i-1] + 1) {
      return { 
        isValid: false, 
        error: "Quick Reply buttons must be grouped together" 
      };
    }
  }
  
  return { isValid: true };
};